import { BoxStyleProps } from "@twilio-paste/core/box";
import { TextStyleProps } from "@twilio-paste/core/text";

export const containerStyles: BoxStyleProps = {
    // border: "none",
    backgroundColor: "colorBackgroundPrimary",
    display: "flex",
    height: "sizeIcon90",
    maxWidth: ["size10", "size20"],
    width: ["size10", "size20"],
    fontSize: "fontSize50",
    alignItems: "center",
    justifyContent: "space-around",
    borderRadius: "borderRadius20",
    borderWidth: "borderWidth10",
    borderColor: "colorBorder",
    color: "colorTextLink",
    cursor: "pointer",
    transition: "background-color 0.2s",
    outline: "0px",
    padding: "space20",
    _hover: {
        backgroundColor: "colorBackgroundPrimaryWeak",
        borderColor: "colorBorderPrimaryWeak",
        boxShadow: "none"
    },
    _focusVisible: {
        backgroundColor: "colorBackgroundPrimaryWeak",
        boxShadow: "none"
    }
};
// eslint-disable-next-line import/no-unused-modules
export const textStyles: TextStyleProps = {
    color: "colorTextIconAvailable",
    paddingX: "space30"
};
